import {
  Box,
  Flex,
  Skeleton,
  SimpleGrid,
} from "@chakra-ui/react";

export const PK12Skeleton = () => {
  return (
    <Box p={8} bg="gray.50" minH="100vh">
      {/* Step Header */}
      <Flex justify="space-between" mb={6}>
        <Skeleton height="28px" width="220px" />
        <Skeleton height="20px" width="80px" />
      </Flex>

      {/* Subtitle */}
      <Skeleton height="18px" width="320px" mb={6} />

      {/* Main Container */}
      <Box
        p={8}
        borderWidth="1px"
        borderRadius="xl"
        bg="white"
        shadow="sm"
        maxW="6xl"
        mx="auto"
      >
        {/* Grade Level Title */}
        <Skeleton height="20px" width="100px" mb={4} />

        {/* Grade Level Buttons */}
        <SimpleGrid columns={{ base: 4, md: 6 }} spacing={4} mb={8}>
          {Array(13)
            .fill("")
            .map((_, i) => (
              <Skeleton
                key={i}
                height="48px"
                borderRadius="md"
              />
            ))}
        </SimpleGrid>

        {/* Subject Title */}
        <Skeleton height="20px" width="80px" mb={4} />

        {/* Subject Buttons */}
        <SimpleGrid columns={{ base: 1, md: 3, lg: 5 }} spacing={4}>
          {Array(5)
            .fill("")
            .map((_, i) => (
              <Skeleton
                key={i}
                height="48px"
                borderRadius="md"
              />
            ))}
        </SimpleGrid>
      </Box>

      {/* Footer Buttons */}
      <Flex justify="space-between" mt={8}>
        <Skeleton height="40px" width="80px" borderRadius="md" />
        <Skeleton height="40px" width="120px" borderRadius="md" />
      </Flex>
    </Box>
  );
};
